import { App } from './App';
import { createRoot } from 'react-dom/client';

//require('datejs');

createRoot(document.getElementById('root')!).render(<App />);
